var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 156,
    viewBox: "0 0 252 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.445 34.1637L107.271 9.01239C106.239 7.19451 104.653 5.6681 102.691 4.60566C100.729 3.54322 98.4706 2.98713 96.1702 3.00023H35.36C32.083 3.00339 28.9413 4.1558 26.6241 6.20462C24.3069 8.25344 23.0036 11.0313 23 13.9288V35.7859C22.9997 36.2644 23.106 36.7382 23.313 37.1803C23.5199 37.6224 23.8234 38.0241 24.206 38.3624C24.5887 38.7007 25.043 38.969 25.543 39.152C26.043 39.335 26.5789 39.429 27.12 39.4287H117.76C118.461 39.4287 119.151 39.2703 119.764 38.9685C120.377 38.6666 120.892 38.2313 121.261 37.7039C121.631 37.1765 121.841 36.5745 121.874 35.9549C121.906 35.3353 121.758 34.7188 121.445 34.1637Z",
    fill: "#376CFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.64 32.143H23V145.071C23 147.97 24.3022 150.75 26.6202 152.799C28.9381 154.849 32.0819 156 35.36 156H216.64C219.918 156 223.062 154.849 225.38 152.799C227.698 150.75 229 147.97 229 145.071V43.0716C229 40.1731 227.698 37.3934 225.38 35.3439C223.062 33.2944 219.918 32.143 216.64 32.143Z",
    fill: "#4294FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.def9775fe59caad9d7536c0c6d25b3e3.svg";
export { ForwardRef as ReactComponent };